// url-utils.js

/**
 * Decorates internal links with specified query parameters from the current page's URL.
 * This is useful for persisting tracking parameters like UTM tags across same-site navigations.
 * @param {string[]} domainsToDecorate - An array of domain hostnames to decorate.
 * @param {string[]} queryParamsToTransfer - An array of query parameter names to transfer.
 * @param {boolean} [log=false] - Whether to log execution details to the console.
 */
export function querystringDragging(domainsToDecorate = [], queryParamsToTransfer = [], log = false) {
  const links = document.querySelectorAll('a[href]'); // Select only links that have an href attribute
  const currentPageQueryParams = new URLSearchParams(window.location.search);

  links.forEach(link => {
    try {
      const linkUrl = new URL(link.href, window.location.origin); // Resolve relative URLs

      // Skip if it's a same-page anchor link
      if (linkUrl.pathname === window.location.pathname && linkUrl.hash && linkUrl.origin === window.location.origin) {
        return;
      }

      // Ensure domainsToDecorate is an array and has items before proceeding
      const isTargetDomain = Array.isArray(domainsToDecorate) && domainsToDecorate.length > 0 &&
        domainsToDecorate.some(domain => {
          // Ensure domain is a string before calling endsWith
          return typeof domain === 'string' && linkUrl.hostname.endsWith(domain);
        });


      if (isTargetDomain) {
        queryParamsToTransfer.forEach(paramName => {
          const paramValue = currentPageQueryParams.get(paramName);
          if (paramValue !== null && paramValue !== '') { // Check for null or empty string
            linkUrl.searchParams.set(paramName, paramValue);
          }
        });
        link.href = linkUrl.toString();
      }
    } catch (error) {
      // console.warn(`Skipping link due to invalid URL: ${link.href}`, error);
    }
  });
}
